<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" style="postion:fixed">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
      <el-link type="primary" style="float:right" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </el-breadcrumb>



    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class=" flex-r-x" style="width:100%;padding-top:30px">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="selectName" placeholder="输入部门名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>

    </el-form>
    <div style="width:100%;height:65vh;overflow:auto">
          <el-table  :data="tableData"  size="small" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
        <el-table-column  prop="RoleName" label="姓名">
        </el-table-column>
        <!-- <el-table-column  prop="TcStaffTypeID" label="所属部门" >
        </el-table-column> -->
        <!-- <el-table-column  prop="TcStaffTypeID" label="所属门店" >
        </el-table-column> -->
        <el-table-column  prop="Note" label="备注" >
        </el-table-column>
                <!-- <el-table-column  prop="Introduce" label="个人介绍" >
        </el-table-column> -->
        <!-- <el-table-column prop="addTime" label="创建时间" >
        </el-table-column>
        <el-table-column prop="ShopName" label="商户名称" >
        </el-table-column> -->
      <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column> -->
      <el-table-column align="center" label="操作" width="250" fixed="right" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <!-- <el-button v-if="scope.row.Isdisable == 0" type="warning" plain size="mini" @click="handlejie(scope.row)">禁用</el-button>
           <el-button v-if="scope.row.Isdisable == 1" type="info" plain size="mini" @click="handlejie(scope.row)">解禁</el-button> -->
          <el-button size="mini" type="primary" @click="setLimits(scope.row)" >权限配置</el-button>
  
          <el-button size="mini" type="info" @click="deleteUser(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <!--列表-->

    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="30%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
         <el-form-item label="角色名称:" prop="RoleName">
          <el-input size="small" v-model="editForm.RoleName" auto-complete="off" placeholder="请输入姓名"  style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
          <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.Note" style="width:90%"></el-input>
        </el-form-item>
    
      </el-form>
 
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
        
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>


    <el-drawer :wrapperClosable= false title="权限配置" :visible.sync="quanxian" :direction="direction" size="30%">
      <div style="padding-bottom:100px">
          <el-tree
              :data="typeList"
              :props="props"
              show-checkbox
              ref="tree"
              default-expand-all
              highlight-current
              node-key="LType">
          </el-tree>
      </div>

      
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="quanxian = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
            @click="baocun"
            >保存</el-button
          >
        </div>
    </el-drawer>
    <!-- </el-dialog> -->
      <el-dialog title="修改密码" :visible.sync="passShow" width="40%" >
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="密码" prop="deptNo">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="topass()">保存</el-button>
      </div>
    </el-dialog>
      <el-dialog title="充值" :visible.sync="chongShow" width="40%">
      <el-form label-width="120px">
        <el-form-item label="充值金额" prop="money">
          <el-input size="small" placeholder="请输入充值金额" v-model="money"  auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="ADDmoney()">充值</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
        quanxian:false,
      formValidate: {
        mainImage: "",
      },
      props: {
          children: 'listsub',
          label: 'Name'
        },
         rolePermissions:[],
       direction: "ltr",
      passShow:false,
      money:'',
      input:'',
      SelectStoresID:this.$route.params.id,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      typeList:[],
      Pwd:'',
      RoleID:'',
      editForm: {
        RoleName:'',
        Limits:'',
        Note:'',
      },
      // rules表单验证

      rules: {
        RoleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        //   Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        //   Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        //   pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        //   money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
        //   ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      DianList:[],
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.getDianList()
       this.getType()
    this.getList()
    //   this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      tosetting(){
         this.$router.push({ path: '/setting/setting'})
      },
      changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      this.getType()
      this.getList()
    },
    getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},


        deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          RoleID:row.ID,
        
        }
        var that = this
        this.ajax('delRole.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
        
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
      baocun(){
                let selectNodes = this.$refs.tree.getCheckedNodes();
                let NodeIDs = [];
                selectNodes.forEach(item =>{
                    NodeIDs.push(item.LType);
                })
                let halfSelectNodes = this.$refs.tree.getHalfCheckedNodes();
                halfSelectNodes.forEach(item=>{
                    NodeIDs.push(item.LType)
                    console.log(item.LType)
                })
                let allStr = NodeIDs.join(",");
              
                var data = { SelectStoresID:this.SelectStoresID,
                                token:localStorage.getItem("token"),
                                StoresID:localStorage.getItem("StoresID"),
                                RoleID:this.RoleID,
                                Limits:allStr
                }
              
              var that = this
                          this.ajax('editRoleLimits.aspx',JSON.stringify(data),"POST",function(res){
                              if (res.orsuccess == "1") {

                                  that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  that.quanxian = false
                                  that.getList()
                                }

                            })

              
        // console.log(allStr)
      },
        setLimits(items){

            this.RoleID = items.ID
            this.quanxian = true;
            console.log(items.Limits)
            let setIds = items.Limits.split(',')
            var set =items.Limits.split(',')
              setIds.forEach((node,index) => {
                this.typeList.forEach(items =>{
                    let itemsList = items.listsub
                    if(itemsList.length > 0){
                      if( node == items.LType){
                            set[index] = 0
                      }
                        
                          itemsList.forEach(item => {
                              if(item.LType == node && item.listsub.length >0){
                                  
                                 set[index] = 0  
                                  
                              }       
                                   
                                  //  console.log(set)
                        });
                        
                    }    
            });
    

              
              })   
            this.$nextTick(function () {
                  this.$refs.tree.setCheckedKeys( set,true);
                })
            },
    handlePassword(){
        this.quanxian = true
    },
    handleEdit(row){
          if (row != undefined && row != 'undefined') {
              this.title = '编辑角色'
       
              this.editForm = row
    
          } else {
              this.title = '添加角色'
                this.editForm = {
                      RoleName:'',
                    Limits:'',
                    Note:'',
                }
          }
          this.editFormVisible = true
    },
    handleCheckChange(data, checked, indeterminate) {
        console.log(data, checked, indeterminate);
         console.log(this.$refs.tree.getCheckedNodes());
      },
    getType(){
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
     
      }
      var that = this
      this.ajax('getListLimits.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.typeList = res.data
                //  loading.close();
          } 
       })
    },
    getList(){

    //  this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID") 

      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListRole.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
 
                 loading.close();
          } 

      })
  
    },

    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面

    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            var data = this.editForm
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID = this.SelectStoresID  
                var that = this
            if(this.title == '添加角色'){
                this.ajax('addRole.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })

            }else {
                data.RoleID = this.editForm.ID
                 this.ajax('editRole.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })
            }
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/operator/role.vue